<template>
<header>
    <nav>
        <span class='mainnavi' @click="navMenu = !navMenu,menus =!menus"><i v-bind:class="{ active: menus }"></i></span>
        <span class='sidedrawer' @click="sideMenu = !sideMenu"><i v-bind:class="{ active: menus }"></i></span>
        
        <transition name='lang'>
            <ul v-show="navMenu">
                <li><router-link to="/about">{{$t('h-about')}}</router-link></li>
                <li><router-link to="/projects">{{$t('h-projects')}}</router-link></li>
                <li><a href="#skills">{{$t('h-skills')}}</a></li>
                <li><router-link to="/contact">{{$t('h-contact')}}</router-link></li>
            </ul>
            

        </transition>
            <div class="locale-changer">
                <select v-model="$i18n.locale">
                   <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
                </select>
            </div>
           
        
    </nav>



    <transition name="slide">
     <aside id="mySidenav" class="sidenav" role="navigation" v-if='sideMenu' @click="sideMenu = !sideMenu"> 
        <div>
          <router-link to="/">Me</router-link>
          <router-link to="/about">	{{$t('h-about')}}</router-link>
          <router-link to="/projects">{{$t('h-projects')}}</router-link>
          <a href="#skills">{{$t('h-skills')}}</a>
          <router-link to="/contact">{{$t('h-contact')}}</router-link>
        </div>
      </aside>
    </transition>
</header>

    
    
 

    
</template>

<script>
export default {

	name: 'MainNav',
	data () {
        return {
            navMenu:false,
            menus:false,
            sideMenu:false,
            langs: ['en', 'jp']
           
        }
    },


}

</script>
<style lang="scss">
.locale-changer {
    select {
        background:none;
        border: none;
        color:#fff;
        text-transform: uppercase;
        option {
             background:#000;
               border: none;
            text-transform: uppercase;
           
        }
    }
}


.lang-enter-active, .lang-leave-active {
  transition: opacity .5s;
}
.lang-enter, .lang-leave-to{
  opacity: 0;
}


.mainnavi {
    display: none;
    p {
     
        letter-spacing: 10px;
    }
}

@keyframes qwe {
    from {opacity:0;}
    to {opacity:1;}
}


@media (min-width:700px) {
.mainnavi {
    display: block;
}
.sidedrawer {
    display: none;
}
}



</style>